import React, { FC } from 'react';
import { WithStyle } from '@ch/common/utils';
import { FormTextAreaProps } from './types';
import { FormTextAreaStyled } from './textarea.styled';

export const FormTextArea: FC<FormTextAreaProps> & WithStyle = ({ as: _as, ref: _ref, ...rest }) => {
  return <FormTextAreaStyled {...rest} />;
};

FormTextArea.defaultProps = {
  $size: 'md',
  $variant: 'default',
  type: 'text',
  disabled: false,
  required: false,
  placeholder: 'Enter',
  $error: false,
};

FormTextArea.displayName = 'FormTextArea';
FormTextArea.Style = FormTextAreaStyled;
